module.exports = "<router-outlet></router-outlet>\n<p-toast key=\"default\" position=\"top-right\" [baseZIndex]=\"9999\"></p-toast>"